module.exports = __webpack_public_path__ + "img/Gerümpel.64b739cf.svg";